import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class ProjectService {
    /**
     * Get all projects
     * @returns {Promise<Array>} Array of projects
     */
    static async getProjectsAsync() {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/list`);
        return response.items || response || [];
    }

    /**
     * Get single project by ID
     * @param {string|number} id - Project ID
     * @returns {Promise<Object>} Project data
     */
    static async getProjectAsync(id) {
        return await NetworkService.getAsync(`${API_BASE_URL}/projects/${id}`);
    }

    /**
     * Get project team members
     * @param {string|number} id - Project ID
     * @returns {Promise<Array>} Team members array
     */
    static async getProjectTeamAsync(id) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${id}/team`);
        return response.items || response || [];
    }

    static async createProjectTeamInvitationsBulkAsync(id, body) {
        const response = await NetworkService.postAsync(`${API_BASE_URL}/projects/${id}/invitations/bulk`, body);
        return response.results || response || [];
    }

    static async createProjectTeamInvitationAcceptAsync(body) {
        const response = await NetworkService.postAsync(`${API_BASE_URL}/projects/invitations/accept`, body);
        return response.results || response || [];
    }

    /**
     * Create or update project
     * @param {FormData} formData - Project data
     * @returns {Promise<Object>} Created/updated project
     */
    static async createUpdateAsync(formData) {
        return await NetworkService.postMultiPartAsync(`${API_BASE_URL}/projects/upsert`, formData);
    }

    static async getProjectCueSheetAsync(id) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${id}/cue-sheet`);
        return response.items || response || [];
    }

    static async createProjectCueSheetItemAsync(id, formData) {
        return await NetworkService.postAsync(`${API_BASE_URL}/projects/${id}/cue-sheet`, formData);
    }

    static async importProjectCueSheetItemsAsync(id, formData) {
        return await NetworkService.postMultiPartAsync(`${API_BASE_URL}/projects/${id}/cue-sheet/import`, formData);
    }

    static async deleteProjectCueSheetItemAsync(id, itemId) {
        return await NetworkService.deleteAsync(`${API_BASE_URL}/projects/${id}/cue-sheet/${itemId}`);
    }

    static async updateProjectCueSheetItemAsync(projectId, itemId, data) {
        return await NetworkService.putAsync(
            `${API_BASE_URL}/projects/${projectId}/cue-sheet/${itemId}`,
            data
        );
    }

    static async updateProjectCueSheetItemsAsync(projectId, payload) {
        return await NetworkService.postAsync(
            `${API_BASE_URL}/projects/${projectId}/cue-sheet/bulk-with-history`,
            payload
        );
    }

    static async cutProjectCueSheetItemAsync(projectId, itemId, firstCut, secondCut) {
        return await NetworkService.postAsync(
            `${API_BASE_URL}/projects/${projectId}/cue-sheet/${itemId}/cut/v2`,
            { first_cut: firstCut, second_cut: secondCut }
        );
    }

    static async getProjectHistoryAsync(id) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${id}/edit-history`);
        return response.items || response || [];
    }

    static async getProjectVideosAsync(id) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${id}/videos/list`);
        return response.items || response || [];
    }

    static async createProjectVideoItemAsync(id, formData) {
        return await NetworkService.postMultiPartAsync(`${API_BASE_URL}/projects/${id}/videos`, formData);
    }

    static async getProjectVideoItemAsync(id, videoId) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${id}/videos/${videoId}`);
        return response.items || response || [];
    }

    static async deleteProjectVideoItemAsync(id, videoId) {
        return await NetworkService.deleteAsync(`${API_BASE_URL}/projects/${id}/videos/${videoId}`);
    }

    static async getProjectMessagesAsync(id, params = {}) {
        const query = new URLSearchParams(params).toString();
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${id}/messages${query ? '?' + query : ''}`);
        return response;
    }

    static async createProjectMessageAsync(id, body, params) {
        return await NetworkService.postAsync(`${API_BASE_URL}/projects/${id}/messages`, body, params);
    }

    static async getCueSheetListAsync() {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/cue-sheet/list`);
        return response.items || response || [];
    }

    /*static async getProjectClipsAsync(id) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${id}/clip/list`);
        return response.items || response || [];
    }

    static async getProjectTimelineAsync(id) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${id}/timeline`);
        return response || {};
    }

    static async saveProjectTimelineAsync(id, data) {
        return await NetworkService.putAsync(`${API_BASE_URL}/projects/${id}/timeline`, data);
    }*/
}
